import { isNil, mapValues, max, min, values } from 'lodash-es';

import {
  baseDriversConfig,
  advancedColumnDriversConfig,
  advancedLineDriversConfig,
} from './drivers';
import { userOverlapChartConfig, timeSpentChartConfig } from './cross-app-usage';
import { keyMetricsConfig } from './key-metrics';

export {
  baseDriversConfig,
  advancedColumnDriversConfig,
  advancedLineDriversConfig,
  userOverlapChartConfig,
  timeSpentChartConfig,
  keyMetricsConfig,
};

export const getCustomExtremes = (series) => {
  const minPoints = mapValues(series, (data) => min(data.map(([, value]) => value)));
  const maxPoints = mapValues(series, (data) => max(data.map(([, value]) => value)));
  const minPoint = min(values(minPoints));
  const maxPoint = max(values(maxPoints));

  if (isNil(minPoint) || isNil(maxPoint)) return [null, null];

  const deviation = (maxPoint - minPoint) * 0.1;

  return [Math.floor(minPoint - deviation), Math.ceil(maxPoint + deviation)];
};
